import types from '@/actions/types';
import useSequence from '@/composables/useSequence';
import useAnalytics from '@/composables/useAnalytics';
import useConfig from '@/composables/useConfig';
import { START_FLOW_ID } from '@/js/constants';
import Base from '@/actions/base';

export default class Home extends Base {
  constructor(params) {
    super(params, types.HOME);
  }

  execute() {
    const { runSequence, interruptSequence } = useSequence();
    const { trackAction } = useAnalytics();
    const { setFlowStateBackToStart, setActiveAvatar } = useConfig();
    trackAction(this);

    return new Promise((resolve) => {
      this.resolve = resolve;
      resolve();
      setActiveAvatar();
      setFlowStateBackToStart(START_FLOW_ID);
      interruptSequence();
      runSequence(START_FLOW_ID);
    });
  }

  stop() {
    this.resolve();
  }
}
